import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import StockTransferModal from "../../core/modals/stocks/stocktransferModal";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { PlusCircle } from "react-feather";
import { ChevronUp } from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
// import { Download } from "react-feather";
import Loader from '../loader/loader';
import { useToast } from '../../Toaster/ToastContext';
import { apiClient } from '../../services/apiClient';

const StockTransfer = () => {
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);
  const hasFetched = useRef(false);
  const { showToast } = useToast();
  const dispatch = useDispatch();
  const header_data = useSelector((state) => state.toggle_header);
  const [stockData, setStockData] = useState([]);
  const [filteredStockData, setFilteredStockData] = useState([]);

  const fetchStockTransfer = async () => {
    if (hasFetched.current) return;
    setLoading(true);
    try {
      const response = await apiClient.post('/get-all-quantity', {
        pageIndex: 0,
        pageSize: 50,
        previousPageIndex: 0,
      })
      if (response.success) {
        setStockData(response.data);
        setFilteredStockData(response.data); 
      } else {
        setStockData([]);
        setFilteredStockData([]);
      }
    } catch (error) {
      showToast(error.message || 'Failed to fetch stock transfer', 'error', 'Stock Transfer');
    } finally {
      setLoading(false);
      hasFetched.current = true;
    }
  };

  useEffect(() => {
    fetchStockTransfer();
  }, []);

  const handleAddNew = () => {
    setEditData(null);
  };

  const resetFetch = () => {
    hasFetched.current = false;
    fetchStockTransfer();
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setFilteredStockData(
      stockData.filter((stock) =>
        stock.from_warehouse.toLowerCase().includes(term) ||
        stock.to_warehouse.toLowerCase().includes(term)
      )
    );
  };

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const columns = [
    {
      title: "From Branch",
      dataIndex: "from_warehouse",
      sorter: (a, b) => a.from_warehouse.length - b.from_warehouse.length,
    },
    {
      title: "To Branch",
      dataIndex: "to_warehouse",
      sorter: (a, b) => a.to_warehouse.length - b.to_warehouse.length,
    },
    // {
    //   title: "No Of Products",
    //   dataIndex: "noOfProducts",
    //   sorter: (a, b) => a.noOfProducts.length - b.noOfProducts.length,
    // },
    {
      title: "Quantity Transferred",
      dataIndex: "quantity_transferred",
      sorter: (a, b) =>
        a.quantity_transferred.length - b.quantity_transferred.length,
    },
    // {
    //   title: "Ref Number",
    //   dataIndex: "refNumber",
    //   sorter: (a, b) => a.refNumber.length - b.refNumber.length,
    // },
    {
      title: "Date",
      dataIndex: "transfer_date",
      sorter: (a, b) => a.transfer_date.length - b.transfer_date.length,
      render: (text) => {
        const date = new Date(text);
        return isNaN(date) ? 'N/A' : date.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).split('/').join('-');
      },
    },
  ];

  return (
    <div>
      <Loader loading={loading} />
      <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title d-flex align-items-center">
              <div>
                <h4>Stock Transfer</h4>
                <h6>Manage your stock transfer</h6>
              </div>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={header_data ? "active" : ""}
                  onClick={() => {
                    dispatch(setToogleHeader(!header_data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <a to="#" className="btn btn-added"
              data-bs-toggle="modal"
              data-bs-target="#add-units"
              onClick={handleAddNew}
            >
              <PlusCircle className="me-2" />
              Add New
            </a>
          </div>
          {/* <div className="page-btn import">
            <Link
              to="#"
              className="btn btn-added color"
              data-bs-toggle="modal"
              data-bs-target="#view-notes"
            >
              <Download className="me-2" />
              Import Tranfer
            </Link>
          </div> */}
        </div>

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    onChange={handleSearch}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <Table
                className="table datanew"
                columns={columns}
                dataSource={filteredStockData}
                rowSelection={null}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>
      <StockTransferModal editData={editData} onUpdate={resetFetch} />
    </div>
    </div>
  );
};

export default StockTransfer;
